module.exports = __webpack_public_path__ + "static/media/摄图网_1.276d9f4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_208/images/摄图网_1.png
// module id = 1705
// module chunks = 0